/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Constants, copy } from '../utils';
import { SettingsService } from '../services';

export const useScale = () => {
  const emptyItem = {
    letter: '',
    from: '',
    to: '',
    note: '',
    // Valores para el placeholder
    _letter: ' ',
    _from: ' ',
    _to: ' ',
    _note: ' ',
  };

  const user = useSelector(state => state.user);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Establece el servicio de acuerdo a la rol del usuario
  const service = useMemo(() => {
    switch (user.level_id) {
      case Constants.USER.LEVELS.SCHOOL: return SettingsService.school;
      case Constants.USER.LEVELS.PROFESSOR: return SettingsService.teacher;
      default: return null;
    }
  }, [user.id]);

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const response = await service?.getQuantifications({ school_id: user.id, perPage: 100 });
      setData(response.data.map(item => ({
        ...item,
        _letter: item.letter,
        _from: item.from,
        _to: item.to,
        _note: item.note,
      })));

    } catch (error) {
      console.log(error)
    }

    setIsLoading(false);
  }

  const add = () => {
    setData([...data, emptyItem]);
  }

  const remove = (index) => {
    setData(data.filter((_, i) => i !== index));
  }

  const onChange = (value, target, index) => {
    setData(s => {
      const data = copy(s);
      data[index][target] = value;
      return data;
    });
  }

  const isValidForm = (showError = true) => {
    const onError = (msg) => {
      if (showError) toast.error(msg);
      return false;
    }

    if (data.length === 0) {
      return onError('Debe agregar al menos un rango de calificación');
    }

    if (data.some(item => item.letter === '' || item.from === '' || item.to === '' || item.note === '')) {
      return onError('Todos los campos son obligatorios');
    }

    let item = data.find(item => parseFloat(item.from) > parseFloat(item.to));
    if (item) {
      return onError(`Los rangos de calificaciones no pueden ser inversos (Letra ${item.letter}: ${item.from} > ${item.to})`);
    }

    return true;
  }

  const submit = async () => {
    if (!isValidForm()) return;
    setIsLoading(true);

    try {
      const form = {
        school_id: user.id,
        quantifications: data.map(item => ({
          id: item.id ?? undefined,
          letter: item.letter,
          from: item.from,
          to: item.to,
          note: item.note,
        })),
      };

      await service?.saveQuantifications(form);
      fetchData();
      toast.success('Datos actualizados correctamente');

    } catch (error) {
      console.log(error)
    }

    setIsLoading(false);
  }

  useEffect(() => {
    fetchData();
  }, []);

  return {
    add,
    data,
    isLoading,
    onChange,
    remove,
    submit,
  }
}
